module.exports = __webpack_public_path__ + "static/media/lisa-back.62cb6495.png";